"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renameSectionMutationOptions = exports.renameSectionMutation = void 0;
const client_1 = require("@apollo/client");
const sectionAndRecipeName_1 = require("../fragments/sectionAndRecipeName");
exports.renameSectionMutation = client_1.gql `
  mutation RenameSection($id: String!, $name: String!) {
    renameSection(id: $id, name: $name) {
      __typename
      errors {
        path
        message
      }
      section {
        ...justSection
      }
    }
  }
  ${sectionAndRecipeName_1.justSectionFragment}
`;
exports.renameSectionMutationOptions = (section) => ({
    variables: { id: section.id, name: section.name },
});
//# sourceMappingURL=renameSection.js.map